// extracted by mini-css-extract-plugin
module.exports = {"delta-pro-ultra-C":"C_delta-pro-ultra-C__8yKCR"};